import { components, useApi } from "@appretio/api";
import { useMutation } from "@tanstack/react-query";

type RestateFPOSInput = components["schemas"]["RestateFPOSInput"];

/**
 * Mutation hook to restate forward period of sales to default values.
 * The caller is responsible for re-fetching grid data after success.
 */
export function useRestateFPOS() {
  const apiClient = useApi();

  return useMutation({
    mutationFn: async (input: RestateFPOSInput) => {
      const response = await apiClient.POST("/v2/forecast/grid/restate-fpos", {
        body: input
      });
      if (!response.data?.result) {
        throw new Error("Missing result in restate FPOS response");
      }
      return response.data.result;
    },
    meta: {
      errorMessage: "Failed to restate forward period of sales"
    }
  });
}
